import { render, staticRenderFns } from "./MsgHelpInfo.vue?vue&type=template&id=28a68e88&scoped=true&"
import script from "./MsgHelpInfo.vue?vue&type=script&lang=js&"
export * from "./MsgHelpInfo.vue?vue&type=script&lang=js&"
import style0 from "./MsgHelpInfo.vue?vue&type=style&index=0&id=28a68e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a68e88",
  null
  
)

export default component.exports